import { css } from '@emotion/css';
import colors from '@/theme/colors';
import { pxToRem } from '@/utils';

const styles = {
  enrollmentGroup: css`
    border: 0;
    margin: 0 0 24px 0;
    padding: 0;
    min-inline-size: 0;
    display: block;
    width: 100%;
  `,
  innerContainer: css`
    background-color: ${colors.platinum};
    padding: 24px 16px 32px 16px;
    border-radius: 12px;
    position: relative;
    & .MuiAutocomplete-inputRoot {
      & .MuiAutocomplete-input {
        text-transform: capitalize;
      }
    }
  `,
  legend: css`
    display: block;
    width: 100%;
    padding: 0;
    margin: 0;
  `,
  cardBorder: css`
    height: 1px;
    border-bottom: 1px solid ${colors.silver};
    z-index: 1;
    position: relative;
    top: 64px;
    margin: 0px 1px;
  `,
  inputWithToolTip: css`
    width: 100%;
    box-sizing: border-box;
    padding-right: 3rem;
  `,
  gradeOptions: css`
    width: 100%;
    padding: 0;
    margin-top: 24px;
    .MuiFormLabel-root {
      font-family: 'Montserrat Regular' !important;
      line-height: 1.45;
      letter-spacing: -0.4px;
      color: ${colors.charcoal} !important;
    }
    ,
    .MuiInputBase-input {
      font-family: 'Montserrat Regular' !important;
      line-height: 1.43;
      letter-spacing: -0.4px;
      color: ${colors.prussian};
      border-bottom-color: ${colors.prussian} !important;
      padding: 6px 0;
    }
  `,
  inlined: css`
    display: block;
  `,
  infoIcon: css`
    padding-left: 15px;
    margin-top: 8px;
  `,
  tooltipButton: css`
    & .MuiIconButton-root {
      color: ${colors.prussian};
      padding: 4px;
      
    }
  `,
  formSectionHeadline: css`
    display: flex;
    justify-content: space-between;
    align-items: baseline;
    margin-bottom: 36px;
  `,
  secondaryName: css`
    font-size: ${pxToRem(13)};
    font-family: 'Proxima Nova', Helvetica, Arial, sans-serif;
    color: ${colors.slate};
    display: block;
  `,
  removeIcon: css`
    cursor: pointer;
    margin-top: -8px;
    margin-right: -8px;
  `,
  ctaLink: css`
    color: ${colors.jungle};
    font-size: ${pxToRem(16)};
    display: block;
    margin-top: 10px;
    cursor: pointer;

    &:hover {
      text-decoration: underline;
      color: ${colors.jungle};
    }
  `,
  footer: css`
    margin-top: 16px;
    display: flex;
    justify-content: flex-end;

    & > div {
      margin-left: 10px;
    }
  `,
  label: css`
    display: block;
    padding-bottom: 8px;
    line-height: 16px;
  `,
  labelGrade: css`
    padding-top: 24px;
  `,
  textInput: css`
    font-size: ${pxToRem(16)} !important;
    color: ${colors.prussian};
    text-transform: capitalize;
    line-height: 24px;
    padding-bottom: 24px;
  `,
  autocomplete: css`
    .MuiFormLabel-root {
      font-family: 'Montserrat Regular' !important;
      line-height: 1.45;
      letter-spacing: -0.4px;
      color: ${colors.charcoal} !important;
    }
    .MuiInputBase-input {
      font-family: 'Montserrat Regular' !important;
      font-size: ${pxToRem(16)} !important;
      line-height: 1.43;
      letter-spacing: -0.4px;
      color: ${colors.prussian};
    }
    .MuiFormHelperText-root {
      span {
        font-family: 'Montserrat Regular';
        font-size: ${pxToRem(11)};
        color: ${colors.dragon};
      }
    }
  `,
  hasError: css`
    border: 1px solid ${colors.dragon};
  `,
  inputGradeError: css`
    .MuiInputBase-input {
      border-bottom: 1px solid ${colors.dragon};
    }
  `,
  inputSchoolError: css`
    .MuiInput-underline:before {
      border-bottom: 1px solid ${colors.dragon};
    }
  `,
};

export default styles;
